import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import TextArea from "../../../common/TextArea";
import {setSaveNewEmployee} from "../../../../_reducers/activitySlice";
import {setNewEmployee, setNewBankInfo, resetNewBankInfo} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import Dropdown from "../../../primer/Dropdown";
import {
    checkPermission,
    getDefaultOptionByValue, getEmployeeBreakOptions, getEmployeeCategoryOptions,
    getEmployeeTypeOptions, getKathestosOptions, getResignationCauseOptions,
    getSexOptions, getWorkingDaysPerWeekOptions, isEmpty
} from "../../../../_helpers/commonFunctions";
import AccountingBox from "../../../primer/AccountingBox";
import BetterCheckBox from "../../../common/BetterCheckBox";
import useErganiInstallationOptions from "../../../../hooks/useErganiInstallationOptions";
import {extendedBankOptions} from "../../../../_data/dummy_banks";
import EditableTable from "../../../primer/Editable-Table";
import {useTranslation} from "../../../../hooks/useTranslation";

const NewEmployee = () => {
    const {t, locale} = useTranslation();
    const dispatch = useDispatch();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const saveNewEmployee = useSelector((state) => state.ACTIVITY.saveNewEmployee);
    const newEmployee = useSelector((state) => state.ACCOUNTING_DATA.newEmployee);
    const newBankInfo = useSelector((state) => state.ACCOUNTING_DATA.newBankInfo);
    const companyHasErgani = useSelector((state) => state.PAYROLL.companyHasErgani);
    const currentDate = new Date();
    const companyInstallations = useErganiInstallationOptions(false);
    const [bankInfoIncrKey, setBankInfoIncrKey] = useState(0);

    const employeeBankInfoColumns = [
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankFriendlyName'),
            field: "bankFriendlyName",
            editable: true,
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankInstitute'),
            field: "bankInstitute",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                options: extendedBankOptions,
            }
        },
        {
            name: "IBAN",
            field: "iban",
            editable: true,
            width: "50%",
            inputType: {
                type: 'text',
            }
        },
    ];

    useEffect(() => {
        setBankInfoIncrKey(bankInfoIncrKey + 1);
    }, [newEmployee.bankInfo]);

    useEffect(() => {
        setBankInfoTableColumns(employeeBankInfoColumns.slice());
    }, [locale]);

    const [bankInfoTableColumns, setBankInfoTableColumns] = useState(employeeBankInfoColumns.slice());

    const handleOnChange = (e, type = "default", ddname = '') => {
        if (!saveNewEmployee) dispatch(setSaveNewEmployee(true));

        let name;
        let value;
        if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'ac') {
            value = e.target.value;
            name = ddname;
        } else if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else if (type === "bcb") {
            if (ddname === "isActive") {
                value = e.target.checked ? "active" : "inActive";
            } else {
                value = e.target.checked;
            }
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        let newData = {};
        newData[name] = value;
        if (name === "resignationDate") {
            if (value) {
                newData.isActive = "inactive";
            } else {
                newData.isActive = "active";
            }
        }
        dispatch(setNewEmployee({...newEmployee, ...newData}));
    }

    const bankInfoTableActions = {
        insert: (e, data) => {
            // Set if editing the form
            if (!saveNewEmployee) {
                dispatch(setSaveNewEmployee(true));
            }

            let tempBankInfo = Object.assign({}, newBankInfo);

            if (e.key !== "Enter") {
                tempBankInfo[data.field] = data.value;
                dispatch(setNewBankInfo(tempBankInfo)); // Ενημέρωση του προσωρινού στο Redux
                if (data.value !== "") {
                    let updatedBankInfo = Object.assign({}, tempBankInfo);
                    let oldBankInfo = newEmployee.bankInfo || [];

                    dispatch(setNewEmployee({
                        ...newEmployee,
                        bankInfo: [...oldBankInfo, updatedBankInfo]
                    }));
                    dispatch(resetNewBankInfo());
                }
            } else {
                let updatedBankInfo = Object.assign({}, tempBankInfo);
                let oldBankInfo = newEmployee.bankInfo || [];

                if (e.key === "Enter" || data.value === "add") {
                    // Εδώ μπορείς να προσθέσεις extra validation αν θες
                    dispatch(setNewEmployee({
                        ...newEmployee,
                        bankInfo: [...oldBankInfo, updatedBankInfo]
                    }));
                    dispatch(resetNewBankInfo());
                    dispatch(setSaveNewEmployee(true));
                }
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveNewEmployee) {
                dispatch(setSaveNewEmployee(true));
            }
            let bankInfo = [...newEmployee.bankInfo];
            bankInfo[rowIndex] = { ...bankInfo[rowIndex], ...data };
            dispatch(setNewEmployee({ ...newEmployee, bankInfo: bankInfo }));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveNewEmployee) {
                dispatch(setSaveNewEmployee(true));
            }
            let bankInfo = [...newEmployee.bankInfo];
            bankInfo.splice(rowIndex, 1);
            dispatch(setNewEmployee({ ...newEmployee, bankInfo: bankInfo }));
        }
    };

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col md={12} className="d-flex align-items-center justify-content-end">
                    <div className="inline-field d-flex align-items-center acremd mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2">{t('PosNew.active')}</label>
                        <BetterCheckBox
                            className="mb-2"
                            name="isActive"
                            checked={newEmployee.isActive === "active"}
                            onChange={(e) => handleOnChange(e, "bcb", "isActive")}
                        />
                    </div>
                </Col>
            </Row>
            <p className="text-muted mb-1">
                <i>{t('EmployeeNew.personalLabel')}</i>
            </p>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.firstName.name')}
                        name="firstName"
                        placeholder={t('EmployeeNew.firstName.placeholder')}
                        value={newEmployee.firstName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.firstName === '' && <div className="text-danger">{t('EmployeeNew.firstName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.lastName.name')}
                        name="lastName"
                        placeholder={t('EmployeeNew.lastName.placeholder')}
                        value={newEmployee.lastName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.lastName === '' && <div className="text-danger">{t('EmployeeNew.lastName.required')}</div>}
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={t('EmployeeNew.sex.name')}
                        name="sex"
                        width="30%"
                        placeholder="Επιλέξτε Φύλο"
                        options={getSexOptions()}
                        enabledValue={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "sex")}
                        value={getDefaultOptionByValue(getSexOptions(), newEmployee.sex, 'value', 'label', 'value')}
                        className={"mb-0"}
                    />
                    {saveNewEmployee && newEmployee.sex === '' && <div className="text-danger">{t('EmployeeNew.sex.required')}</div>}
                </Col>
                <Col md={2}>
                    <DateBox
                        label={t('EmployeeNew.birthDate.name')}
                        name="birthDate"
                        allowOtherYears={true}
                        required={true}
                        minDate={new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())}
                        maxDate={new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate())}
                        selected={newEmployee.birthDate}
                        onChange={(e) => handleOnChange(e, 'dp', 'birthDate')}
                    />
                    {saveNewEmployee && newEmployee.birthDate === '' && <div className="text-danger">{t('EmployeeNew.birthDate.required')}</div>}
                </Col>
                <Col md={2}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.vatNumber.name')}
                        name="vatNumber"
                        placeholder={t('EmployeeNew.vatNumber.placeholder')}
                        value={newEmployee.vatNumber}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.vatNumber === '' && <div className="text-danger">{t('EmployeeNew.vatNumber.required')}</div>}
                </Col>
            </Row>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.fatherFirstName.name')}
                        name="fatherFirstName"
                        placeholder={t('EmployeeNew.fatherFirstName.placeholder')}
                        value={newEmployee.fatherFirstName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.fatherFirstName === '' && <div className="text-danger">{t('EmployeeNew.fatherFirstName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.fatherLastName.name')}
                        name="fatherLastName"
                        placeholder={t('EmployeeNew.fatherLastName.placeholder')}
                        value={newEmployee.fatherLastName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.fatherLastName === '' && <div className="text-danger">{t('EmployeeNew.fatherLastName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.motherFirstName.name')}
                        name="motherFirstName"
                        placeholder={t('EmployeeNew.motherFirstName.placeholder')}
                        value={newEmployee.motherFirstName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.motherFirstName === '' &&
                        <div className="text-danger">{t('EmployeeNew.motherFirstName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.motherLastName.name')}
                        name="motherLastName"
                        placeholder={t('EmployeeNew.motherLastName.placeholder')}
                        value={newEmployee.motherLastName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.motherLastName === '' && <div className="text-danger">{t('EmployeeNew.motherLastName.required')}</div>}
                </Col>
            </Row>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label="Τηλέφωνο"
                        name="phone"
                        placeholder="Εισάγετε Τηλέφωνο"
                        value={newEmployee.phone}
                        required={false}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        label={"E-Mail"}
                        name={"email"}
                        placeholder={"Εισάγετε E-Mail"}
                        value={newEmployee.email}
                        required={false}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <hr/>
            <p className="text-muted mt-2 mb-1">
                <i>{t('EmployeeNew.securityLabel')}</i>
            </p>
            <Row className={"mb-2"}>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.amka.name')}
                        name="amka"
                        placeholder={t('EmployeeNew.amka.placeholder')}
                        value={newEmployee.amka}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.amka === '' && <div className="text-danger">{t('EmployeeNew.amka.required')}</div>}
                </Col>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.amika.name')}
                        name="amika"
                        placeholder={t('EmployeeNew.amika.placeholder')}
                        value={newEmployee.amika}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.amika === '' && <div className="text-danger">{t('EmployeeNew.amika.required')}</div>}
                </Col>
                <Col md={4}>
                    <Input
                        label={"ΑΜΑ"}
                        name={"ama"}
                        placeholder={"Εισάγετε ΑΜΑ"}
                        value={newEmployee.ama}
                        required={false}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <hr/>
            <p className="text-muted mt-2 mb-1">
                <i>{t('EmployeeNew.workingLabel')}</i>
            </p>
            <Row>
                <Col md={3}>
                    <Dropdown
                        label={t('EmployeeNew.employeeCategory.name')}
                        name="employeeCategory"
                        width="30%"
                        placeholder={t('EmployeeNew.employeeCategory.placeholder')}
                        options={getEmployeeCategoryOptions()}
                        enabledValue={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "employeeCategory")}
                        value={getDefaultOptionByValue(getEmployeeCategoryOptions(), newEmployee.employeeCategory, 'value', 'label', 'value')}
                        className={"mb-1"}
                    />
                    {saveNewEmployee && newEmployee.employeeCategory === '' &&
                        <div className="text-danger">{t('EmployeeNew.employeeCategory.required')}</div>}
                </Col>
                <Col md={3}>
                    <Dropdown
                        label={t('EmployeeNew.employeeType.name')}
                        name="employeeType"
                        width="30%"
                        placeholder={t('EmployeeNew.employeeType.placeholder')}
                        options={getEmployeeTypeOptions()}
                        enabledValue={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "employeeType")}
                        value={getDefaultOptionByValue(getEmployeeTypeOptions(), newEmployee.employeeType, 'value', 'label', 'value')}
                        className={"mb-1"}
                    />
                    {saveNewEmployee && newEmployee.employeeType === '' &&
                        <div className="text-danger">{t('EmployeeNew.employeeType.required')}</div>}
                </Col>
                <Col md={6}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.specialty.name')}
                        name="specialty"
                        placeholder={t('EmployeeNew.specialty.placeholder')}
                        value={newEmployee.specialty}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewEmployee && newEmployee.specialty === '' &&
                        <div className="text-danger">{t('EmployeeNew.specialty.required')}</div>}
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={4}>
                    <Dropdown
                        label={t('EmployeeNew.installation.name')}
                        options={companyInstallations}
                        value={getDefaultOptionByValue(companyInstallations, newEmployee.installation, 'value', 'label', 'value')}
                        enabledValue={true}
                        searchEnable={true}
                        required={true}
                        name="installation"
                        onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                        className={"mb-1"}
                    />
                    {saveNewEmployee && newEmployee.installation === '' &&
                        <div className="text-danger">{t('EmployeeNew.installation.required')}</div>}
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Εβδομαδιαίες ημέρες εργασίας"}
                        name={"workingDaysPerWeek"}
                        key={Math.random()}
                        options={getWorkingDaysPerWeekOptions()}
                        defaultValue={getDefaultOptionByValue(getWorkingDaysPerWeekOptions(), newEmployee.workingDaysPerWeek, 'value', 'label', 'value')}
                        onChange={(e) => handleOnChange(e, 'dd', 'workingDaysPerWeek')}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"workingHoursPerWeek"}
                        label={"Εβδομαδιαίες ώρες εργασίας"}
                        type={"number"}
                        value={newEmployee.workingHoursPerWeek}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"symbatikesWorkingHoursPerWeek"}
                        label={"Συμβ. εβδ. ώρες εργασίας"}
                        type={"number"}
                        value={newEmployee.symbatikesWorkingHoursPerWeek}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"workingExperienceYears"}
                        label={"Χρόνια προϋπηρεσίας"}
                        type={"number"}
                        value={newEmployee.workingExperienceYears}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={2}>
                    <Input
                        name={"firstYearPermits"}
                        label={"Άδειες πρώτου έτους"}
                        type={"number"}
                        value={newEmployee.firstYearPermits}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"breakMinutes"}
                        label={"Χρόνος διαλείμματος (σε λεπτά)"}
                        type={"number"}
                        value={newEmployee.breakMinutes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Διάλειμμα εντός/εκτός ωραρίου"}
                        name={"breakMinutesWhen"}
                        key={Math.random()}
                        options={getEmployeeBreakOptions()}
                        defaultValue={getDefaultOptionByValue(getEmployeeBreakOptions(), newEmployee.breakMinutesWhen, 'value', 'label', 'value')}
                        onChange={(e) => handleOnChange(e, 'dd', 'breakMinutesWhen')}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Καθεστώς απασχόλησης"}
                        name={"kathestos"}
                        key={Math.random()}
                        options={getKathestosOptions()}
                        defaultValue={getDefaultOptionByValue(getKathestosOptions(), newEmployee.kathestos, 'value', 'label', 'value')}
                        onChange={(e) => handleOnChange(e, 'dd', 'kathestos')}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        classes="w-100"
                        label={t('EmployeeNew.employmentDate.name')}
                        name="employmentDate"
                        allowOtherYears={true}
                        required={true}
                        minDate={new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())}
                        selected={newEmployee.employmentDate}
                        onChange={(e) => handleOnChange(e, 'dp', 'employmentDate')}
                    />
                    {saveNewEmployee && newEmployee.installation === '' &&
                        <div className="text-danger">{t('EmployeeNew.employmentDate.required')}</div>}
                </Col>
                <Col md={2}>
                    <label className="" htmlFor="prefered-price">{t('EmployeeNew.salary.name')}</label>
                    <AccountingBox
                        fromAccountTable={true}
                        name="salary"
                        className="form-control"
                        placeholder={t('ProductsNewGeneralEdit.preferredPrice.placeholder')}
                        defaultValue={newEmployee.salary}
                        onChange={(e) => handleOnChange(e, 'ac', 'salary')}
                    />
                </Col>
            </Row>
            {companyHasErgani && (
                <Row className={"mt-2 mb-2"}>
                    <Col md={12}>
                        <Row>
                            <Col md={2}>
                                <BetterCheckBox
                                    name={"erganiCard"}
                                    className={"mt-4"}
                                    text={"Κάρτα εργασίας"}
                                    checked={newEmployee.erganiCard}
                                    onChange={(e) => handleOnChange(e, "bcb", "erganiCard")}
                                />
                            </Col>
                            {newEmployee.erganiCard === true && (
                                <React.Fragment>
                                    <Col md={3}>
                                        <Input
                                            name={"flexibleAttendanceMinutes"}
                                            label={"Ευέλικτος Χρόνος Προσέλευσης (σε λεπτά)"}
                                            type={"number"}
                                            required={true}
                                            value={newEmployee.flexibleAttendanceMinutes}
                                            onChange={(e) => handleOnChange(e)}
                                        />
                                        {saveNewEmployee && isEmpty(newEmployee.flexibleAttendanceMinutes) && <div className="text-danger">Απαιτείται ο Χρόνος Προσέλευσης</div>}
                                    </Col>
                                    {checkPermission("custom-sales", permissionsData) && (
                                        <Col md={3}>
                                            <BetterCheckBox
                                                name={"autoSendErganiCard"}
                                                text={"Αυτόματη αποστολή κάρτας εργασίας"}
                                                className={"mt-4"}
                                                checked={newEmployee.autoSendErganiCard}
                                                onChange={(e) => handleOnChange(e, "bcb", "autoSendErganiCard")}
                                            />
                                        </Col>
                                    )}
                                </React.Fragment>
                            )}
                        </Row>
                    </Col>
                </Row>
            )}
            <Row className={"mt-3"}>
                <Col md={2}>
                    <DateBox
                        classes="w-100 mb-3"
                        label={t('EmployeeNew.resignationDate')}
                        name="resignationDate"
                        allowOtherYears={true}
                        minDate={newEmployee.employmentDate ? newEmployee.employmentDate : new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())}
                        maxDate={new Date()}
                        selected={newEmployee.resignationDate}
                        onChange={(e) => handleOnChange(e, 'dp', 'resignationDate')}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={t('EmployeeNew.resignationCause')}
                        options={getResignationCauseOptions()}
                        value={getDefaultOptionByValue(getResignationCauseOptions(), newEmployee.resignationCause, 'value', 'label', 'value')}
                        enabledValue={true}
                        searchEnable={true}
                        name="resignationCause"
                        onChange={(e) => handleOnChange(e, 'dd', 'resignationCause')}
                    />
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={12}>
                    <div className="text-muted mb-2"><i>{t('ClientsGeneralEdit.bankInfoTable.title')}</i></div>
                    <EditableTable
                        tableName="Employee Bank Info"
                        key={"Employee Bank Info" + bankInfoIncrKey}
                        allowActions={true}
                        columns={bankInfoTableColumns}
                        data={newEmployee.bankInfo}
                        allowInsertRow={true}
                        enableNewRowCheckbox={true}
                        onUpdate={bankInfoTableActions}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div className="text-muted mb-2"><i>{t('PosNew.notes')}</i></div>
                    <TextArea
                        rows="4"
                        placeholder={t('PosNew.addNotes')}
                        name="notes"
                        limit="1000"
                        value={newEmployee.notes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default NewEmployee;
